import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';
import Body from './Body.js';
import Header from './Header.js';
import Separator from './Separator.js';
import Title from './Title.js';
import CgnLogo from './CgnLogo.js';
import Gap from './Gap.js';

/**
Il componente Application permette di definire un'applicazione composta da due parti:
un Header ed un corpo in cui l'header è fisso in cima alla pagina e scrolla solo il corpo.
All'interno del componente è poi possibile specificare i children desiderati.
 */
function Application(_a) {
    var { children = undefined, className = '' } = _a, others = __rest(_a, ["children", "className"]);
    return (jsx("div", Object.assign({}, others, { className: cns('application application-flex', className), children: children })));
}
Application.Header = Header;
Application.Separator = Separator;
Application.Title = Title;
Application.CgnLogo = CgnLogo;
Application.Body = Body;
Application.Gap = Gap;

export { Application as default };
